/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import PropTypes from 'prop-types';
import filterProps from './filter-props';

/**
 * React component that wraps a simple HTML <img /> tag.
 *
 * @param {object} props props
 * @returns {HTMLElement} The image element
 */
export default function Image(props) {
  return <img { ...filterProps('img', props) } />;
}

Image.propTypes = {
  /** The image source */
  src: PropTypes.string
};

